export const SETUP_OMITTABLE_KEYS = Object.freeze(['location', 'roles', 'bmc']);

export function normalizeSetupOmitted(value) {
  if (!Array.isArray(value)) return [];
  const seen = new Set();
  const normalized = [];
  for (const raw of value) {
    const key = String(raw || '').trim().toLowerCase();
    if (!SETUP_OMITTABLE_KEYS.includes(key) || seen.has(key)) continue;
    seen.add(key);
    normalized.push(key);
  }
  return normalized;
}

function hasLocation(serverLike) {
  return Boolean(serverLike?.location_id || serverLike?.location_name);
}

function hasRoles(serverLike) {
  if (Array.isArray(serverLike?.roles) && serverLike.roles.length > 0) return true;
  if (Array.isArray(serverLike?.role_ids) && serverLike.role_ids.length > 0) return true;
  if (Array.isArray(serverLike?.windows_roles) && serverLike.windows_roles.length > 0) return true;
  if (Array.isArray(serverLike?.storage_blob?.windows_roles) && serverLike.storage_blob.windows_roles.length > 0) return true;
  if (Boolean(serverLike?.is_hypervisor)) return true;
  if (Boolean(serverLike?.detected_hypervisor_type)) return true;
  if (String(serverLike?.role_display || '').trim()) return true;
  if (String(serverLike?.role || '').trim()) return true;
  return false;
}

function hasBmc(serverLike, options = {}) {
  if (options.hasBmcComponent) return true;
  return Boolean(String(serverLike?.ip_address || '').trim());
}

export function getServerSetupWarnings(serverLike, options = {}) {
  const omitted = new Set(normalizeSetupOmitted(serverLike?.setup_omitted));
  const warnings = [];

  if (!hasLocation(serverLike) && !omitted.has('location')) {
    warnings.push({
      key: 'location',
      title: 'Ubicación pendiente',
      message: 'Falta asignar ubicación física al servidor.',
    });
  }

  if (!hasRoles(serverLike) && !omitted.has('roles')) {
    warnings.push({
      key: 'roles',
      title: 'Roles pendientes',
      message: 'Falta definir al menos un rol o servicio.',
    });
  }

  if (!hasBmc(serverLike, options) && !omitted.has('bmc')) {
    warnings.push({
      key: 'bmc',
      title: 'BMC/iLO pendiente',
      message: 'Falta configurar la gestión fuera de banda (IP BMC/iLO).',
    });
  }

  return warnings;
}
